import { onceIdleOrInViewport } from '@js/util/helpers.js'
import { select } from '@js/util/select.js'

select('.image-swiper', async swiperElement => {
  await onceIdleOrInViewport(swiperElement)
  const { default: Swiper, FreeMode } = await import('swiper')

  /**
   * @type {import('swiper').Swiper}
   */
  const options = {
    modules: [FreeMode],
    direction: 'horizontal',
    loop: true,
    spaceBetween: 32,
    slidesPerView: 'auto',
    slidesOffsetBefore: 30,
    slidesOffsetAfter: 30,
    centeredSlides: true,
    freeMode: true,
    breakpointsInverse: true,
    breakpoints: {
      320: {
        spaceBetween: 20,
      },
      600: {
        spaceBetween: 24,
      },
      800: {
        spaceBetween: 28,
      },
      1200: {
        spaceBetween: 32,
      },
    },
  }

  const swiper = new Swiper(swiperElement.querySelector('.swiper'), options)

  swiperElement.querySelector('.custom-button-prev').addEventListener('click', () => {
    swiper.slidePrev()
  })

  swiperElement.querySelector('.custom-button-next').addEventListener('click', () => {
    swiper.slideNext()
  })

  let observer = new IntersectionObserver(([{ isIntersecting }]) => {
    if (isIntersecting) {
      for (let img of swiperElement.querySelectorAll('img[loading="lazy"]')) {
        img.removeAttribute('loading')
      }
      observer.disconnect()
    }
  })
  observer.observe(swiperElement)

  return () => {
    swiper.destroy()
    observer.disconnect()
  }
})
